import { CREATE_LABEL_GROUP, DELETE_LABEL_GROUP, FETCH_LABEL_GROUPS, LOGOUT, UPDATE_LABEL_GROUP } from '../actions/types';
import { handleStart, handleSuccess } from '../lib/reduxUtils';
import LabelGroup from '../entities/labelGroup';

const initialState = {
	workspace_label_groups: [],
	project_label_groups: [],
	workspace_id: null
};

export const labelGroups = ( state = initialState, action ) => {
	switch ( action.type ) {
	case FETCH_LABEL_GROUPS:
		return handleSuccess( state, action, () => ( {
			workspace_label_groups: ( action.payload.workspace_label_groups || [] )
				.map( g => LabelGroup.fromJSON( g ) ),
			project_label_groups: ( action.payload.project_label_groups || [] )
				.map( g => LabelGroup.fromJSON( g ) ),
			workspace_id: action.meta.workspaceID
		} ) );
	case CREATE_LABEL_GROUP:
		return handleSuccess( state, action, ( prevState ) => {
			const group = LabelGroup.fromJSON( action.payload );
			const key = group.groupType === 'Workspace' ? 'workspace_label_groups' : 'project_label_groups';
			return {
				...prevState,
				[ key ]: [ ...prevState[ key ], group ]
			};
		} );
	case UPDATE_LABEL_GROUP:
		return handleSuccess( state, action, ( prevState ) => {
			const group = LabelGroup.fromJSON( action.payload );
			const key = group.groupType === 'Workspace' ? 'workspace_label_groups' : 'project_label_groups';
			return {
				...prevState,
				[ key ]: prevState[ key ].map( g => ( g.id === group.id ? group : g ) )
			};
		} );
	case DELETE_LABEL_GROUP:
		return handleSuccess( state, action, ( prevState ) => {
			const group = LabelGroup.fromJSON( action.payload );
			const key = group.groupType === 'Workspace' ? 'workspace_label_groups' : 'project_label_groups';
			return {
				...prevState,
				[ key ]: prevState[ key ].filter( g => g.id !== group.id )
			};
		} );
	case LOGOUT:
		return handleStart( state, action, () => initialState );
	default:
		return state;
	}
};
